export const IS_LOADING = 'IS_LOADING';
export const DATA_LOADING = 'DATA_LOADING';
export const SET_AUTH = 'SET_AUTH';

// Testimonial

export const SET_TESTIMONIAL_DATA = 'SET_TESTIMONIAL_DATA';
